'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _theme = require('../components/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  background: _propTypes2.default.oneOf(Object.keys(_theme2.default.backgrounds)),
  interactive: _propTypes2.default.bool
};

var parseBackground = function parseBackground(val, interactive) {
  if (_theme2.default.backgrounds.hasOwnProperty(val)) {
    var bg = _theme2.default.backgrounds[val];
    return (0, _glamor.css)(_extends({
      color: bg.textColor,
      backgroundColor: bg.backgroundColor,
      borderColor: bg.borderColor + ' !important'
    }, interactive ? {
      '&:hover, &:active': {
        borderColor: bg.borderColorInteractive + ' !important'
      }
    } : {}));
  }
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var background = _ref.background,
      interactive = _ref.interactive,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['background', 'interactive', 'className']);

  return _extends({
    className: background !== undefined ? (0, _classnames2.default)('' + parseBackground(background, interactive), className) : className
  }, props);
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/background.js
// module id = 1140
// module chunks = 0